import { useRef } from "react";
import { useTranslation } from "react-i18next";

function ColorDot({ label, value, onChange }) {
  const ref = useRef(null);
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
      <div
        onClick={() => ref.current.click()}
        title={label}
        style={{
          width: 20, height: 20,
          borderRadius: "50%",
          backgroundColor: value,
          border: "2px solid rgba(255,255,255,0.25)",
          cursor: "pointer",
          flexShrink: 0,
        }}
      />
      <span style={{ fontSize: 9, color: "#888", whiteSpace: "nowrap" }}>{label}</span>
      <input ref={ref} type="color" value={value} onChange={(e) => onChange(e.target.value)}
        style={{ position: "absolute", opacity: 0, width: 0, height: 0, pointerEvents: "none" }} />
    </div>
  );
}

export default function TeamColorsPicker({ colors, onChange }) {
  const { t } = useTranslation();
  return (
    <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
      <ColorDot label={t("team.colorHome")} value={colors.local}  onChange={(v) => onChange("local",  v)} />
      <ColorDot label={t("team.colorAway")} value={colors.away}   onChange={(v) => onChange("away",   v)} />
    </div>
  );
}
